import { m } from "framer-motion";
import language from "react-syntax-highlighter/dist/esm/languages/hljs/1c";

export const translations = {
    en: {
        help: 'Need help? Contact <a href="mailto:support@abstracht.com">support@abstracht.com</a>',
        no_data_found: "No data found...",
        yes: "Yes",
        save: "Save",
        close: "Close",
        delete: "Delete",
        create: "Create",
        search_filter: "Filter data by searching...",
        reload: "Reload",
        no_data_found_by_search: "No data found matching your search...",
        no_data: "No data available...",
        name: "Name",
        full_name: "Full name",
        title: "Title",
        description: "Description",
        message: "Message",
        mandatory_field: "Mandatory field",

        type_confirm: "To confirm, type",
        documentation: "Documentation",

        select: "Select",
        selected: "selected",
        create_new: "Create new",
        here: "here",

        created_at: "Created at",
        no_logs: "No logs available",
        log: "Log",
        error_occurred: "An error occurred",
        connect: "Connect",
        disconnect: "Disconnect",
        no_abilities: "No abilities found...",
        loading: "Loading...",
        different_version: "The deployed version and your connected version differ. We recommend reconnecting to sync them.",
        reasoning: "reasoning",

        insufficient_funds: "Your wallet balance is too low. Please add funds or enable auto top-up.",
        open_directory: "Open directory",
        stop: "Stop",
        send: "Send",
        cancel: "Cancel",
        next: "Next",
        back: "Back",

        public: "Public",
        custom: "Custom",

        website: {
            navbar: {
                dashboard: "Dashboard",
                waitlist: "Join waitlist",
                start_now: "Start now",
                login: "Login"
            },
            sidebar: {
                abilities: "Abilities",
                fine_tuning: "Fine tuning and agents",
                team_managment: "Team managment",
                pricing: "Pricing"
            },
            footer: {
                all_rights: "All rights reserved.",
                legal: "Legal Notes",
                privacy: "Privacy policy",
                terms: "Terms and Conditions",
                t0r: 'Abstracht is a <a href="https://t0.abstracht.com">Type Zero</a> company'
            },

            main_title: "Build your AI",
            main_subtitle: "Give expert models unlimited capability, then stand back.",
            build_software: "Build software",
            create_agents: "Create agents",
            fine_tune: "Fine-tune LLMs",
            centralized_search: "Centralized search",
            team_orch: "Team orchestration",
            input_placeholder: "Describe what you want to build...",

            phrases: [
                "Generate a consolidated Q4 financial report including treasury position, cash flow projections, and variance analysis across all subsidiaries.",
                "Analyze customer churn over the last 12 months and identify the primary behavioral and revenue drivers impacting retention.",
                "Create a standardized onboarding workflow for new enterprise clients, including compliance checks and internal approval flows.",
                "Automate invoice reconciliation by matching ERP records with bank transactions and flagging inconsistencies for review.",
                "Deploy an AI support agent trained on internal documentation to handle Tier 1 customer service inquiries.",
                "Draft a GDPR-compliant data governance policy covering data access, storage, retention, and third-party integrations.",
                "Forecast revenue for the next fiscal year using historical performance, seasonality trends, and current pipeline data.",
                "Optimize supply chain logistics by identifying bottlenecks in procurement, warehousing, and last-mile delivery.",
                "Generate a board-ready executive summary outlining operational KPIs, risk exposure, and strategic initiatives.",
                "Monitor regulatory changes across EU markets and automatically update internal compliance documentation."
            ],
            pricing: {
                title: "Pricing",
                subtitle: "See pricing for personal, businesses and enterprise plans",
                monthly: "Monthly",
                yearly: "Yearly",
                custom: "Custom",
                more_info: 'More info about pricing can be found <a href="https://www.abstracht.com/pricing"  target="_blank" rel="noopener noreferrer">here</a>'
            },
            how_payments_work: {
                one_title: "How payments work",
                one_subtitle: " Payments depend on the services you use. Your account operates on a prepaid wallet system.  You can add funds using a credit card (SEPA support coming soon). Your balance is automatically used as you consume services.",
                two_title: "AI Usage",
                two_subtitle: "AI (LLM) usage is billed in real time based on the number of input and output tokens processed. Pricing varies by model.",
                three_title: "Abilities",
                three_subtitle: "Abilities are billed per execution. Pricing is calculated based on execution time, compute usage, and number of requests.",
                four_title: "Actions",
                four_subtitle: "   One-time actions are billed at $0.01 per execution. Scheduled actions are billed at $0.01 per day while active.",
                five_title: "What happens if your wallet has no credit?",
                five_subtitle: "  If your wallet balance reaches zero, all services (AI, Abilities, and Actions) will stop immediately. To resume usage, you must top up your wallet.",
            },
            use_cases: {
                use_case_data: [
                    {
                        kicker: "Data",
                        title: "Unified data access",
                        desc: "Easily import data from multiple sources, create custom connectors, or deploy pre-built databases with a single click. The data is processed and structured so both you and the model can read and retrieve it efficiently.",
                    },
                    {
                        kicker: "Intelligence",
                        title: "Smart LLM management",
                        desc: "Select from a variety of LLMs and choose whether to fine-tune them for specific use cases. Each LLM comes with an integrated Cognitive Memory, allowing it to retrieve relevant information when needed instead of relying solely on context.",
                    },
                    {
                        kicker: "Scale",
                        title: "Seamless team scaling",
                        desc: "Create teams and users, and scale your personalized LLM across autoscalable clusters effortlessly, ensuring performance and accessibility for all members.",
                    },
                ]
            },
            ai_enterprise: {
                kicker: "AI FOR ENTERPRISE",
                title: "Deploy AI at Scale",
                subtitle: "Build, integrate, and scale AI solutions across your organization.",

            },
            sales: {
                contact_btn: "Get early access",
                subtitle: "Be among the first to experience Abstracht",
                message_placeholder: "Leave a brief message...",
                email_err_mex: "Email is required",
                name_err_mex: "Full name is required",
                req_success: "We've received your request!",
                thanks: "Thanks for reaching out, we'll get back to you within 1–2 business days.",
                back_home_btn: "Back to homepage",
            }

        },
        register_form: {
            create_account: "Create an account",
            newsletter: "I would like to receive news and updates.",
            privacy_continue: 'By continuing i accept the <a href="/privacy">Privacy policy </a> | <a href="/terms-and-conditions">Terms and conditions</Link>',
            with_google: "with Google",
            name: "Name",
            surname: "Surname",
            phone: "Phone",
            repeat_password: "Repeat password",
            button_register: "Sign Up",
            already_registered: "Already registered?",
            go_login: "Login",
            email_format: "The email format is incorrect...",
            password_err: "Password must be at least 10 characters long and contain uppercase letters, lowercase letters, special characters, and numbers..",
            password_match: "Passowrds don't match...",
            red_fields: "Check the required fields...",
            email_already_present: "Email already present...",
            errors_back: "An error was detected...retry",
            problem_back: "There is a problem with the access...rety in a few minutes",
            terms_conditions_desc: "I have read and accept the",
            t_c: "Terms and conditions",
            privacy_policy_desc: "I have read and accept the",
            p_p: "Privacy Policy",
            button_login: "Login",
            dont_have_account: "Don't have an account?",
            go_register: "Register",
            invalid_email_pass: "invalid email or password...retry",
            welcome_to: "Welcome to",
            description_one: "Built for massive data operations and intelligent cloud orchestration, Abstracht brings performance and simplicity together with lightning-fast storage, compute power, and vector intelligence managed by a purpose-built AI.",
            welcome_back: "Welcome back!",
            update_mex: "The Abstracht Python SDK has arrived — install it today and integrate effortlessly.",
        },
        verification: {
            title: "Verifying your email...",
            verified_title: "Email verified",
            verified_subtitle: "Your account has been successfully verified. You'll be redirected to shortly.",
            failed_verified_title: "Verification failed...",
            failed_verified_subtitle: "The verification link is invalid or has expired.",
            verify_email_title: "Verify your email!",
            verify_email_subtitle: "We've sent a verification link to ",
            verify_email_message: "Please check your inbox (and spam folder) and click the link to activate your account.",
            resend_btn: "Resend email",
            email_sent: "Email sent successfully!",
            email_sent_sub: "Please check your inbox."
        },
        onboarding: {
            five_options: "You have to select three options...",
            one_option: "You have to select one option...",
            welcome: "Welcome",
            welcome_sub: "Let's get your account set up. This will only take a moment.",
            ready: "I'm ready",
            continue: "Continue",
            back: "Back",
            language: {
                title: "Choose a language",
                subtitle: "You can always change it later",
                warning: "Most LLMs are primarily trained on English-language data, so even if you preselect another language, the model may still respond in English at times."
            },
            personal_info: {
                phone_prefix_required: "Phone prefix is required...",
                phone_required: "Phone is required...",
                invalid_phone: "Invalid phone number format",
                street_required: "Street is required...",
                street_n_required: "Street number is required...",
                city_required: "City is required...",
                country_required: "Country is required...",

                title: "Profile",
                subtitle: "Let's complete your profile setup",
                phone: "Phone",
                street_n: "Street & number",
                city: "City",
                country: "Country",
                no_countries: "No countries found...",
                billing_matches: " Billing information matches provided data",
                billing_title: "Billing info",
                billing_subtitle: "Add the billing details",
            },
            experience: {
                title: "Choose your experience",
                subtitle: "You can always change it later",
                light: "Light",
                dark: "Dark",
                system: "System"
            },
            about_you: {
                title: "Let's talk about you...",
                subtitle: "What describes you best",
                about_you_options: [
                    { value: "developer", label: "Developer / Engineer" },
                    { value: "designer", label: "Designer" },
                    { value: "product_manager", label: "Product Manager" },
                    { value: "it_devops", label: "IT / DevOps" },

                    { value: "marketing", label: "Marketing Professional" },
                    { value: "sales", label: "Sales Professional" },
                    { value: "operations", label: "Operations" },
                    { value: "finance", label: "Finance" },
                    { value: "hr", label: "HR / People Ops" },
                    { value: "customer_support", label: "Customer Support" },

                    { value: "founder", label: "Founder / Co-Founder" },
                    { value: "executive", label: "Executive (CEO, CTO, etc.)" },
                    { value: "manager", label: "Manager" },

                    { value: "creator", label: "Content Creator" },
                    { value: "writer", label: "Writer" },
                    { value: "artist", label: "Artist" },

                    { value: "tradesperson", label: "Skilled Tradesperson" },
                    { value: "mechanic", label: "Mechanic" },
                    { value: "barber", label: "Barber / Hairdresser" },

                    { value: "hospitality_worker", label: "Hospitality Worker" },
                    { value: "retail_worker", label: "Retail Worker" },
                    { value: "driver", label: "Driver / Delivery" },

                    { value: "student", label: "Student" },
                    { value: "teacher", label: "Teacher / Educator" },

                    { value: "freelancer", label: "Freelancer / Self-employed" },
                    { value: "employee", label: "Employee" },

                    { value: "other", label: "Other" }
                ]
            },
            team: {
                title: "About your team...",
                subtitle: "How many people will work with you",
                about_you_options: [
                    { value: "only_1", label: "Only me" },
                    { value: "1_5", label: "1 to 5 people" },
                    { value: "5_10", label: "5 to 10 people" },
                    { value: "10_25", label: "10 to 25 people" },
                    { value: "25_100", label: "25 to 100 people" },
                    { value: "100_200", label: "100 to 200 people" },
                    { value: "200_more", label: "more than 200" },
                ]
            },
            payment: {
                title: "Complete checkout",
                subtitle: "Complete the checkout for your subscription. <br />You can always change it later in the billing section.",
                checkout_for: "Checkout for",
                summary: "Payment summary",
                ammount: "Ammount",
                next_payment: "Next payment",
                date_info: "The date for the next payment is in the following format: DD/MM/YYYY",
                interval: "Interval",
                recurring: "Recurring",
            },
            done: {
                title: "You are ready!",
                subtitle: "You're all set up and ready to start!",
                open_dashboard: "Open dashboard"
            }
        }
    },

}